import { composeClassNames } from "@faedev/editor-utils";
import { Col, Row } from "react-bootstrap";
import Heading from "src/components/Heading";
import gutter from "src/functions/gutter";
import { sAlign } from "src/styles/sAlign.module.scss";
import { sList } from "src/styles/sList.module.scss";

function UserTermsPrivacyEn2() {
  return (
    <div>
      <Heading
        type={`h3`}
        title={
          <>
            {`II.`}
            <br />
            {`User account`}
          </>
        }
        className={composeClassNames([sAlign, "center"])}
        style={gutter(`margin`, `top`, `md`)}
      />
      <Row>
        <Col sm={6} xs={12}>
          <ol className={sList}>
            <li>{`Based on the User registration made on the website, the User can access its User interface (hereinafter referred to as the "User account").`}</li>
            <li>{`When registering, the User is obliged to state all data correctly and truthfully. The User is obliged to update the data specified in the User account whenever they change. The data provided by the User in the User account are considered correct by the Provider.`}</li>
            <li>{`Access to the User account is secured by the User name and password. The User is obliged to maintain confidentiality regarding the information necessary to access their User account.`}</li>
          </ol>
        </Col>
        <Col sm={6} xs={12}>
          <ol start={4} className={sList}>
            <li>{`The User is not entitled to allow the use of the User account to third parties.`}</li>
            <li>{`The User acknowledges that the User account may not be available around the clock, especially with regard to the necessary maintenance of the Provider's hardware and software, or necessary maintenance of third party hardware and software.`}</li>
          </ol>
        </Col>
      </Row>
    </div>
  );
}

export default UserTermsPrivacyEn2;
